/* Clarity project ylk030x4hm; public editorial pages only. */
(() => {
  'use strict';
  if (document.documentElement.dataset.bpPreview !== 'false') return;
  if (/^\/(?:account|customer_authentication|cart|checkout|checkouts|orders|search)(?:\/|$)/.test(location.pathname) || location.pathname === '/pages/contact') return;
  const projectId = 'ylk030x4hm';
  let loaded = false;
  const allowed = () => Boolean(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed());
  function sync() {
    const permitted = allowed();
    if (!permitted && !loaded) return;
    if (!loaded) {
      loaded = true;
      document.querySelectorAll('form').forEach(form => form.setAttribute('data-clarity-mask', 'true'));
      window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      window.clarity('consentv2', { analytics_Storage: 'granted', ad_Storage: 'denied' });
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/' + projectId;
      document.head.append(script);
    } else {
      window.clarity('consentv2', { analytics_Storage: permitted ? 'granted' : 'denied', ad_Storage: 'denied' });
      // Official cookie erasure API when consent is withdrawn.
      if (!permitted) window.clarity('consent', false);
    }
  }
  document.addEventListener('visitorConsentCollected', sync);
  if (window.Shopify?.customerPrivacy) sync();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) sync(); });
})();
